<template>
  <div
    class="publicThemeDialog"
    v-if="currThemeObj"
    :style="{
      '--mixtmt_publicThemeDialog_cardBgColor':
        currThemeObj.cssStyle.publicThemeDialog_cardBgColor,
    }"
  >
    <div class="dialog_pop" v-show="isShowDialog"></div>
    <div class="dialog_card_bg" v-show="isShowDialog">
      <div class="dialog_card">
        <div class="dialogCard_header">
          <span
            class="dialog_title"
            v-text="
              dialogObj && dialogObj.dialogText ? dialogObj.dialogText : ''
            "
          ></span>
          <span class="dialog_btn">
            <span @click="clickBtn(false)">取 消</span>
            <span @click="clickBtn(true)" class="ok">确 定</span>
          </span>
        </div>
        <div
          class="toast_warning"
          v-if="errorTipText"
          :class="errorTipFlag ? 'slideT2B' : ''"
        >
          <span class="errorTipTextIcon el-icon-circle-close"></span>
          <span class="errorTipText" v-text="errorTipText"></span>
        </div>
        <div class="dialogCard_body">
          <span class="dialogCard_body_left">
            <span class="cardItem_group">
              <span class="cardItemGroup_header">
                <span class="headerInfor">
                  <span class="headerInfor_title" v-text="'设计风格'"></span>
                  <span class="headerInfor_tipIcon">
                    <el-tooltip
                      effect="dark"
                      content="设计风格最少选择一种"
                      placement="top"
                      popper-class="publicThemeDialog_toolTip"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </span>
                </span>
              </span>
              <span class="cardItemGroup_body" v-if="analysisItemStyles">
                <span
                  class="imageItem"
                  v-for="styleItem in analysisItemStyles"
                  :key="styleItem.styleId"
                  :class="styleItem.act ? 'act' : ''"
                  @click="clickStyleItem(styleItem)"
                >
                  <span class="imageSpan">
                    <img
                      v-if="styleItem.stylePicture"
                      :src="styleItem.stylePicture"
                    />
                    <span v-else class="defaultPic"></span>
                    <div class="choice-img__input" aria-hidden="true">
                      <svg class="icon" viewBox="0 0 16 16">
                        <path
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                          d="M2 8l4 4 8-8"
                        ></path>
                      </svg>
                    </div>
                  </span>
                  <span
                    class="imageItem_name"
                    v-text="styleItem.styleName"
                  ></span>
                </span>
              </span>
            </span>
          </span>
          <span class="dialogCard_body_right">
            <span
              class="cardItem_group"
              v-for="currOptInfor in optionList"
              :key="currOptInfor.id"
            >
              <span class="cardItemGroup_header">
                <span class="headerInfor">
                  <span
                    class="headerInfor_title"
                    v-text="currOptInfor.name"
                  ></span>
                </span>
              </span>
              <span class="cardItemGroup_body">
                <span class="optionArea">
                  <span
                    class="optionItem"
                    v-for="optItem in currOptInfor.list"
                    :key="optItem.title"
                  >
                    <span
                      class="optionItem_title"
                      v-text="`${optItem.title}：`"
                    ></span>
                    <template v-if="currOptInfor.isEdit">
                      <span
                        class="optionItem_select fadeIn"
                        v-show="optItem.type === 'date'"
                      >
                        <el-date-picker
                          v-model="optItem.curId"
                          popper-class="datePicker_publickThemeDialog small"
                          type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                          @change="changeDate(optItem, currOptInfor)"
                        ></el-date-picker>
                      </span>
                      <span
                        class="optionItem_select fadeIn"
                        v-show="optItem.type === 'select'"
                      >
                        <el-select
                          v-model="optItem.curId"
                          placeholder="请选择（必选项）"
                          popper-class="datePicker_select_opt"
                          :popper-append-to-body="false"
                          @change="selectChangeRoom(optItem, currOptInfor)"
                        >
                          <el-option
                            v-for="item in optItem.list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </span>
                      <!-- <span
                        class="optionItem_radio fadeIn"
                        v-show="optItem.type === 'radio'"
                      >
                        <base_custom_switch
                          :currThemeObj="currThemeObj"
                          :data="optItem.list"
                          :flexDirection="'publicThemeDialog_switch'"
                          @clickSwitchEvent="clickSwitch"
                        ></base_custom_switch>
                      </span> -->
                    </template>
                    <template v-else>
                      <span
                        class="optionItem_value"
                        v-text="optItem.value"
                      ></span>
                      <span
                        class="optionItem_tip"
                        v-show="optItem.isChange"
                        v-text="'已修改'"
                      ></span>
                    </template>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- 分享主题的弹窗 -->
<script>
import {
  https_package_getPackageRoom,
  https_broadcast_postBroadcasts,
  https_broadcast_postBroadcastShareState,
  // https_broadcast_postSaveBroadcastShareState,
} from '@api/platfrom_base_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
// import base_custom_switch from '@components/base/custom_switch.vue'
export default {
  name: 'publicThemeDialog',
  mixins: [cup_base_data_mixin],
  // components: { base_custom_switch },
  props: {
    isDialogFlag: {
      type: Boolean,
      default: false,
    },
    dialogObj: {
      type: Object,
      default: () => ({
        analysisItemId: null,
        dialogType: '',
        dialogText: '',
        mid: 0,
        useSceneArr: [],
        analysisItemStyles: [],
        graphicsId: 0,
        multipleChoiceShareFixedBtn_modeType: null,
      }),
    },
    commitBeforeCheckoutCallback: {
      // 提交时验证数据是否正确，有返回值： {isCheckoutFlag:true|false, errorTipText: ''}
      type: [Function, null],
      default: null,
    },
  },
  data() {
    return {
      isShowDialog: false,
      toParentData: null,
      optionList: [],
      broadcastOpt: {
        id: 'broadcastList',
        name: '播出单',
        act: false,
        isEdit: true, //true：展示区域dom变为可以编辑区域；false：展示区域dom只是显示，不能编辑
        list: [
          // {
          //   type: 'date',
          //   state: 'date',
          //   title: '日期',
          //   curId: '2023-11-20',
          //   oldId: '',
          //   value: '',
          // },
          {
            type: 'select',
            state: 'room',
            title: '演播室',
            curId: '',
            value: '',
            // list: [
            //   {
            //     name: 'E18演播室',
            //     id: '1',
            //   },
            //   {
            //     name: '咪咕演播室',
            //     id: '2',
            //   },
            // ],
          },
          {
            type: 'select',
            state: 'playerList',
            title: '播出单',
            curId: '',
            oldId: '',
            value: '',
            // list: [
            //   {
            //     name: '播出单1',
            //     id: '1',
            //   },
            //   {
            //     name: '播出单2',
            //     id: '2',
            //   },
            // ],
          },
          // {
          //   type: 'radio',
          //   state: 'execute',
          //   title: '设置',
          //   curId: '1',
          //   oldId: '',
          //   value: '',
          //   list: [
          //     {
          //       id: '1',
          //       name: '当天生效',
          //       act: true,
          //       optId: 'broadcastList',
          //     },
          //     {
          //       id: '2',
          //       name: '单次生效',
          //       act: false,
          //       optId: 'broadcastList',
          //     },
          //   ],
          // },
        ],
      },
      dataPackageOpt: {
        id: 'dataPackagList',
        name: '数据包装',
        act: false,
        isEdit: false,
        list: [
          {
            type: 'string',
            title: '日期',
            curId: '',
            oldId: '',
            value: '',
          },
        ],
      },
      errorTipFlag: false,
      errorTipText: '',
    }
  },
  watch: {
    isShowDialog(newVal, oldVal) {
      // 如果是从b到a页面，则不缓存b
      // 注意 路由那么要与组件name一致
      console.debug(oldVal, newVal)
      if (!newVal) {
        // 关闭时，向父组件传递数据
        this.toParentEvent(this.toParentData)
      }
    },
    // dialogObj(newVal, oldVal) {
    //   // 如果是从b到a页面，则不缓存b
    //   // 注意 路由那么要与组件name一致
    //   console.debug(oldVal, newVal)
    //   if (
    //     JSON.stringify(newVal.analysisItemStyles) !==
    //     JSON.stringify(oldVal.analysisItemStyles)
    //   ) {
    //     this.analysisItemStyles = newVal.analysisItemStyles
    //   }
    // },
  },
  created() {
    console.debug(
      'created publicThemeDialog:',
      this.dialogObj,
      this.isDialogFlag,
      this.currThemeObj,
      this.currGroup,
      window.mixtmt_platfrom.needPublicThemeData
    )
    const initOptionList = [
      {
        id: 'broadcastList',
        name: '播出单',
        list: [
          {
            type: 'select',
            state: 'room',
            title: '演播室',
            curId: '',
            value: '',
            // list: [
            //   {
            //     name: 'E18演播室',
            //     id: '1',
            //   },
            //   {
            //     name: '咪咕演播室',
            //     id: '2',
            //   },
            // ],
          },
          {
            type: 'select',
            state: 'playerList',
            title: '播出单',
            curId: '',
            oldId: '',
            value: '',
            // list: [
            //   {
            //     name: '播出单1',
            //     id: '1',
            //   },
            //   {
            //     name: '播出单2',
            //     id: '2',
            //   },
            // ],
          },
        ],
      },
      {
        id: 'dataPackagList',
        name: '数据包装',
        list: [
          {
            type: 'string',
            title: '日期',
            curId: '',
            oldId: '',
            value: '',
          },
        ],
      },
    ]
    const optionList = []
    this.dialogObj.useSceneArr.forEach((useScene) => {
      optionList.push(initOptionList[useScene])
    })
    this.optionList = optionList

    if (this.currGroup) {
      this.init()
    }
  },
  computed: {
    analysisItemStyles() {
      return this.dialogObj && this.dialogObj.analysisItemStyles
        ? this.dialogObj.analysisItemStyles
        : []
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.isShowDialog = this.isDialogFlag
      let optionList = []
      // 获取 组的配置信息; 数据包装中的日期来着这个接口
      await this.getGroupOptMap()
      if (this.dialogObj.useSceneArr.includes('0')) {
        // 播出单拥有该主题
        await this.getPackageRoom()
        await this.getPlayerListDatas(this.currGroupOptMap)
        if (this.broadcastOpt.list && this.broadcastOpt.list.length > 0) {
          this.broadcastOpt.list.forEach((item) => {
            if (item.state === 'date') {
              item.curId = this.currGroupOptMap.date
              item.value = this.currGroupOptMap.date
            } else if (item.state === 'room') {
              item.curId = this.currGroupOptMap.roomId
              item.list = this.roomArr
            } else if (item.state === 'playerList') {
              item.curId = this.currGroupOptMap.playerItemId
              item.list = this.playerList
            }
          })
          this.broadcastOpt.list.forEach((item) => {
            if (item.list && item.list.length > 0) {
              item.list.forEach((cell) => {
                if (item.curId === cell.id) {
                  item.value = cell.name
                }
              })
            }
          })
        }
        optionList.push(this.broadcastOpt)
      }
      if (this.dialogObj.useSceneArr.includes('1')) {
        // 数据包装拥有该主题
        optionList.push(this.dataPackageOpt)
      }
      this.optionList = optionList

      console.debug('optionList:', optionList)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    toParentEvent(data) {
      // 这里是触发分享弹窗事件
      console.debug('toParentEvent:', data)
      this.$emit('publicThemeDialogEvent', data)
    },
    async changeDate(dateObj, currOptInfor) {
      console.debug('changeDate:', dateObj)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let optMap = JSON.parse(JSON.stringify(this.currGroupOptMap))
      optMap.date = dateObj.curId
      await this.getPlayerListDatas(optMap)
      currOptInfor.list.forEach((item) => {
        if (item.state === 'playerList') {
          item.list = this.playerList
          item.curId = this.playerList[0].id
        }
      })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async selectChangeRoom(curItem, currOptInfor) {
      // 切换演播室
      if (curItem.state !== 'room') return
      console.debug('selectChangeRoom:', curItem, currOptInfor)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let optMap = JSON.parse(JSON.stringify(this.currGroupOptMap))
      optMap.roomId = curItem.curId
      optMap.date = currOptInfor.list[0].curId
      await this.getPlayerListDatas(optMap)
      currOptInfor.list.forEach((item) => {
        if (item.state === 'playerList') {
          item.list = this.playerList
          item.curId = this.playerList[0].id
        }
      })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    // clickSwitch(item) {
    //  // 单选框的点击事件
    //   let optionList = JSON.parse(JSON.stringify(this.optionList))
    //   let optId = item.optId
    //   optionList.forEach((optItem) => {
    //     if (optItem.id === optId) {
    //       optItem.list.forEach((listItem) => {
    //         if (listItem.state === 'execute') {
    //           listItem.curId = item.id
    //           listItem.list.forEach((switchItem) => {
    //             if (switchItem.id == item.id) {
    //               switchItem.act = true
    //               listItem.val = item.name
    //             } else {
    //               switchItem.act = false
    //             }
    //           })
    //         }
    //       })
    //     }
    //   })
    //   this.optionList = optionList
    // },
    clickBtn(flag) {
      this.optSave(this.optionList[0])
      let isCloseDialogFlag = true // 是否关闭弹窗，无论【取消|确定】；如果【确定】有的主题可能需要走验证函数；true:正常情况；false:异常情况，验证未通过，提示错误信息
      this.toParentData = null
      if (flag) {
        this.toParentData = {
          flag: flag,
          data: {
            analysisItemId: this.dialogObj.analysisItemId,
            // editThemeTitle: this.editThemeTitle,
            mid: this.dialogObj.mid,
            roomId: this.onceOptMap ? this.onceOptMap.roomId : '',
            playerItemId: this.onceOptMap ? this.onceOptMap.playerItemId : '',
            graphicsId: this.dialogObj.graphicsId,
            multipleChoiceShareFixedBtn_modeType: this.dialogObj
              .multipleChoiceShareFixedBtn_modeType
              ? this.dialogObj.multipleChoiceShareFixedBtn_modeType
              : null,
            analysisItemStyles: this.dialogObj.analysisItemStyles,
          },
        }
        if (this.commitBeforeCheckoutCallback) {
          let { isCheckoutFlag, errorTipText } =
            this.commitBeforeCheckoutCallback(
              this.dialogObj &&
                this.dialogObj.multipleChoiceShareFixedBtn_modeType
                ? this.dialogObj.multipleChoiceShareFixedBtn_modeType
                : null
            ) // 返回验证{isCheckoutFlag:true|false, errorTipText: ''}结果
          isCloseDialogFlag = isCheckoutFlag
          this.errorTipText = errorTipText
        }
      }

      // 风格必须选一种才能提交
      let isStyleItemAct = false
      this.dialogObj.analysisItemStyles.forEach((styleItem) => {
        if (styleItem.act) {
          isStyleItemAct = true
        }
      })
      if (!isStyleItemAct) {
        this.errorTipText = '请至少选择一种风格'
      }
      if ((isStyleItemAct && isCloseDialogFlag) || !flag) {
        // commitBeforeCheckoutCallback 和 风格都验证通过，则可以提交，否则验证失败
        // 当【取消】时，不要验证通过，直接关闭弹窗
        isCloseDialogFlag = true
      } else {
        isCloseDialogFlag = false
      }

      if (isCloseDialogFlag) {
        this.isShowDialog = false
      } else {
        // 验证未通过，所以提示错误信息
        this.errorTipFlag = true
        window.setTimeout(() => {
          this.errorTipFlag = false
        }, 3 * 1000)
      }
    },
    clickStyleItem(item) {
      console.debug('actStyleItemEvent', item)
      this.$emit('actStyleItemEvent', item)
    },
    async optSave(currOptInfor) {
      let optMap = {}
      currOptInfor.list.forEach((rowItem) => {
        if (rowItem.state === 'date') {
          optMap.date = rowItem.curId
        } else if (rowItem.state === 'room') {
          optMap.roomId = rowItem.curId
        } else if (rowItem.state === 'playerList') {
          optMap.playerItemId = rowItem.curId
        }
      })
      this.onceOptMap = optMap
    },
    async getPackageRoom() {
      let params = {
        groupId: this.currGroup.groupId,
      }
      await https_package_getPackageRoom(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.roomArr = res.data.map((val) => {
              val.id = val.id + ''
              val.themeType = 'room'
              return val
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPlayerListDatas(optMap) {
      let params = {
        groupId: this.currGroup.groupId,
        packageId: optMap.roomId,
        competitionId: this.currCid,
        seasonId: this.currSid,
        date: optMap.date,
      }
      await https_broadcast_postBroadcasts(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.playerList = res.data.map((item) => {
              let obj = {
                id: item.broadcastId,
                name: item.broadcastName,
                themeNum: item.subjectNum,
                isAct: false, //播出单被选中
                isRemove: item.broadcastType, //是否可以删除; 0:默认不可以删；1:新增可以删
              }
              return obj
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getGroupOptMap() {
      // 获取存储服务器 组的播出单配置文件
      const params = {
        groupId: this.currGroup.groupId,
        competitionId: this.currCid,
        seasonId: this.currSid,
      }
      await https_broadcast_postBroadcastShareState(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.currGroupOptMap = {
              date: res.data.date,
              roomId: res.data.packageId + '',
              playerItemId: res.data.broadcastId + '',
            }
            let dataPackageOpt = this.dataPackageOpt
            dataPackageOpt.list[0].curId = res.data.todayDate
            dataPackageOpt.list[0].value = res.data.todayDate
            this.dataPackageOpt = dataPackageOpt
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss">
.publicThemeDialog {
  .dialog_pop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1600;
    background-color: var(--mixtmt_greyColor2);
    width: 100%;
    height: 100%;
  }
  .dialog_card_bg {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1610;
    background-color: var(--mixtmt_publicThemeDialog_cardBgColor);
    width: 80%;
    height: auto;
    transform: translate(-50%, -50%);
    border-radius: 1.25vw;
    overflow: hidden;
    .dialog_card {
      --dialog_card_size: 4.16vw;
      position: relative;
      width: 100%;
      height: auto;
      padding-top: var(--dialog_card_size);
      .dialogCard_header {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        background-color: var(--mixtmt_whiteColor);
        width: 100%;
        padding: 0 2%;
        height: var(--dialog_card_size);
        border-bottom: 1px solid var(--mixtmt_greyColor0);
        .dialog_title {
          font-size: 1.1vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor2);
        }
        .dialog_btn {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: center;
          width: auto;
          flex-direction: row-reverse;
          span {
            padding: 0 1.388vw;
            width: auto;
            height: 2.5vw;
            background-color: var(--mixtmt_whiteColor);
            line-height: calc(2.5vw - 2px);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor6);
            border-radius: 0.347vw;
            &.ok {
              background-color: var(--mixtmt_subColor1_1);
              border: 1px solid var(--mixtmt_subColor1_1);
              color: var(--mixtmt_whiteColor);
            }
            &:nth-child(2) {
              margin-right: 1.388vw;
            }
          }
        }
      }
      .toast_warning {
        position: absolute;
        top: var(--dialog_card_size);
        left: 10%;
        z-index: 8;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--mixtmt_errColor);
        width: 80%;
        padding: 0.694vw 2%;
        height: auto;
        color: var(--mixtmt_whiteColor);
        font-size: 0.974vw;
        line-height: 1.1vw;
        border-radius: 0 0 calc(var(--dialog_card_size) / 3)
          calc(var(--dialog_card_size) / 3);
        transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        -webkit-transform: translateY(-100%);
        transform: translateY(-100%);
        &.slideT2B {
          -webkit-transform: translateY(0);
          transform: translateY(0);
        }
        .errorTipTextIcon {
          width: 1.388vw;
          height: 1.388vw;
          font-size: 1.38vw;
          color: var(--mixtmt_whiteColor);
        }
        .errorTipText {
          padding: 0 0.694vw;
        }
      }
      .dialogCard_body {
        width: 100%;
        height: auto;
        min-height: 50vh;
        /* max-height: 80vh; */
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        /* overflow: auto; */
        padding: 2%;
        .dialogCard_body_left {
          /* 左侧风格列表最高 height: calc(70vh + 5.122vw + 2px) */
          width: 20%;
          height: auto;
          .cardItemGroup_body {
            max-height: 70vh;
            overflow: auto;
          }
        }
        .dialogCard_body_right {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          width: 78%;
          height: auto;
          .cardItem_group {
            margin-top: 2%;
            &:first-child {
              margin-top: 0;
            }
          }
        }
      }
    }
  }

  .cardItem_group {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    border-radius: 0.694vw;
    border: 1px solid var(--mixtmt_greyColor0);
    padding: 0.974vw 1.25vw;
    .cardItemGroup_header {
      position: relative;
      width: 100%;
      height: 2.2vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 0.974vw;
      &::before {
        content: '\20';
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 2;
        width: 3.25vw;
        height: 0.22vw;
        background-color: var(--mixtmt_mainColor);
        border-radius: 0.125vw;
      }
      .headerInfor {
        width: 100%;
        height: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .headerInfor_title {
          font-size: 1.1vw;
          color: var(--mixtmt_greyColor3);
          font-weight: bold;
          padding-right: 0.347vw;
        }
        .headerInfor_tipIcon {
          position: relative;
          width: 1.388vw;
          height: 1.388vw;
          & > i {
            font-size: 1.388vw;
            color: var(--mixtmt_greyColor0);
          }
        }
      }
    }
    .cardItemGroup_body {
      width: 100%;
      height: auto;
      padding: 0 0.125vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      .imageItem {
        width: 100%;
        height: auto;
        margin-top: 0.974vw;
        border-radius: 0.347vw;
        transition: transform 0.3s;
        border: 1px solid var(--mixtmt_greyColor0);
        box-shadow: 0 0.3px 0.4px hsla(230, 13%, 9%, 0.02),
          0 0.9px 1.5px hsla(230, 13%, 9%, 0.045),
          0 3.5px 6px hsla(230, 13%, 9%, 0.09);
        &.act {
          border: 1px solid var(--mixtmt_mainColor);
          .imageSpan {
            .choice-img__input {
              opacity: 1;
              .icon > * {
                stroke-dashoffset: 0;
              }
            }
          }
        }
        &:first-child {
          margin-top: 0;
        }
        .imageSpan {
          position: relative;
          display: block;
          width: 100%;
          padding-top: 56.27%;
          overflow: hidden;
          img {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 5;
            width: 100%;
            height: 100%;
            object-fit: contain;
            overflow: hidden;
          }
          .defaultPic {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 4;
            width: 100%;
            height: 100%;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor14);
          }
          .choice-img__input {
            --iconBgSize: 4.5vw;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 10;
            transform: translate(1px, -1px);
            background-color: var(--mixtmt_mainColor);
            width: var(--iconBgSize);
            height: var(--iconBgSize);
            -webkit-clip-path: polygon(15% 0%, 100% 0%, 100% 85%);
            clip-path: polygon(15% 0%, 100% 0%, 100% 85%);
            pointer-events: none;
            opacity: 0;
            .icon {
              --size: 1.5vw;
              position: absolute;
              top: calc(var(--iconBgSize) / 4 - var(--size) / 2);
              right: calc(var(--iconBgSize) / 4 - var(--size) / 2);
              font-size: var(--size);
              color: var(--mixtmt_whiteColor);
              font-size: var(--size);
              height: var(--size);
              width: var(--size);
              display: inline-block;
              fill: currentColor;
              line-height: 1;
              flex-shrink: 0;
              max-width: initial;
              & > * {
                transition: stroke-dashoffset 0.3s;
                stroke-dasharray: 18;
                stroke-dashoffset: 18;
              }
            }
          }
        }
        .imageItem_name {
          display: block;
          width: 100%;
          height: auto;
          padding: 0.694vw;
          font-size: 0.974vw;
        }
      }
    }
  }

  .optionArea {
    position: relative;
    width: 100%;
    height: auto;
    /* border-radius: 0 0 0.694vw 0.694vw; */
    border: 1px solid var(--mixtmt_greyColor8);
    border-top: 0;
    padding: 0 1.388vw 3.2vw 1.388vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .optBtn_area {
      position: absolute;
      bottom: 0;
      right: 0.2vw;
      z-index: 2;
      width: 2.4vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      border-radius: 1.2vw;
      &.saveState {
        width: 5.6vw;
      }
      .editArea {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .iconBox {
          width: 100%;
          height: 2.4vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          background-color: var(--mixtmt_greyColor7);
          border-radius: 1.2vw;
          svg.svg_icon {
            fill: var(--mixtmt_greyColor6);
          }
        }
      }
      .cancelSaveArea {
        position: relative;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        .iconBox {
          width: 50%;
          height: 2.4vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          background-color: var(--mixtmt_greyColor7);
          &:first-child {
            border-radius: 1.2vw 0 0 1.2vw;
          }
          &:last-child {
            border-radius: 0 1.2vw 1.2vw 0;
          }
          svg.svg_icon {
            fill: var(--mixtmt_greyColor6);
          }
        }
        &::after {
          content: '\20';
          position: absolute;
          left: 50%;
          top: 0;
          z-index: 2;
          width: 1px;
          height: 100%;
          background-color: var(--mixtmt_greyColor8);
        }
      }
    }
    .optionItem {
      width: 50%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      height: auto;
      padding: 0.694vw 0;
      font-size: 1.11vw;
      .optionItem_title {
        width: 6.94vw;
        height: 2.778vw;
        line-height: 2.778vw;
        text-align: right;
        color: var(--mixtmt_greyColor2);
      }
      .optionItem_value {
        /* width: calc(100% - 6.94vw); */
        width: 12.5vw;
        height: 2.778vw;
        line-height: 2.778vw;
        text-align: left;
        padding-left: 2vw;
        background-color: var(--mixtmt_greyColor7);
        color: var(--mixtmt_greyColor3);
        /* font-weight: bold; */
        border-radius: 0.278vw;
      }
      .optionItem_tip {
        height: 2.778vw;
        line-height: 2.778vw;
        text-align: left;
        font-size: 0.833vw;
        padding-left: 1.11vw;
        color: var(--mixtmt_errColor);
      }
      .optionItem_select {
        opacity: 1;
        &.fadeIn {
          animation: fadeIn 0.6s linear;
        }
        .el-input__inner {
          width: 12.5vw;
          height: 2.778vw;
          line-height: 2.778vw;
        }
        .el-input--prefix .el-input__inner {
          padding-left: 3vw;
        }
        .el-input--suffix .el-input__inner {
          padding-right: 3vw;
        }
      }
      .optionItem_radio {
        opacity: 1;
        &.fadeIn {
          animation: fadeIn 0.6s linear;
        }
      }
    }
    .optTip {
      position: absolute;
      left: 1.68vw;
      bottom: 0;
      z-index: 2;
      width: 100%;
      line-height: 2.4vw;
      font-size: 0.833vw;
      color: var(--mixtmt_errColor);
      opacity: 1;
      &.fadeIn {
        animation: fadeIn 0.6s linear;
      }
    }
  }
  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}

.mixtmt_pc .publicThemeDialog {
  .dialog_card_bg {
    .dialog_card {
      .dialogCard_header {
        .dialog_btn {
          span {
            cursor: pointer;
            &:hover {
              background-color: var(--mixtmt_greyColor0);
              color: var(--mixtmt_greyColor2);
              border-color: var(--mixtmt_greyColor0);
              &.ok {
                background-color: var(--mixtmt_mainColor);
                border-color: var(--mixtmt_mainColor);
                color: var(--mixtmt_whiteColor);
              }
            }
          }
        }
      }
      .cardItemGroup_body {
        .imageItem {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  .cardItem_group {
    .cardItemGroup_header {
      .headerInfor {
        .headerInfor_tipIcon {
          &:hover {
            & > i {
              cursor: pointer;
              color: var(--mixtmt_greyColor2);
            }
          }
        }
      }
    }
  }
  .optionArea {
    .optBtn_area {
      .editArea {
        .iconBox:hover {
          cursor: pointer;
          background-color: var(--mixtmt_mainColor);
          svg.svg_icon {
            fill: var(--mixtmt_whiteColor);
          }
        }
      }
      .cancelSaveArea {
        .iconBox:hover {
          cursor: pointer;
          background-color: var(--mixtmt_mainColor);
          svg.svg_icon {
            fill: var(--mixtmt_whiteColor);
          }
        }
        &:hover::after {
          background-color: var(--mixtmt_whiteColor);
        }
      }
    }
  }
}
</style>
